import BlogPage from "../components/Post";

import Header from "../components/home/header";

const BlogPost = () => {
  return (
    <div className="blogPageIntro">
      <Header />
      <BlogPage />
    </div>
  );
};
export default BlogPost;
